import { Typography } from "@mui/material"
import { Grid } from "@mui/material"

export function NetworkError(): JSX.Element {
    return (
        <div>
            <Grid item spacing={3} sx={{ mt: 3,ml:3, height: '100vh' }}>
                <Typography variant="h1" component="h2" textAlign='center'>
                    Network Error
                </Typography>
                <Typography variant="h3" component="div" textAlign='left'>
                ただいまofflineです。
                </Typography>
                <Typography variant="h3" component="div" textAlign='left'>
                ネットワーク接続をご確認ください
                </Typography>
            </Grid>
        </div>
    )
}